<template>
  <el-card shadow="always">
    <div slot="header" class="clearfix">
      <el-tabs v-model="activeName" style="width:248px; margin: 0 auto -14px auto;">
        <el-tab-pane label="填写贴士" name="tip"></el-tab-pane>
        <el-tab-pane label="查看案例" name="case"></el-tab-pane>
        <el-tab-pane label="常用动词" name="verb"></el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="activeName == 'tip'">
      <el-select v-model="tipCategory" placeholder="请选择" @change="onTipCategoryChange" style="width:100%">
        <el-option v-for="item in tipCategoryOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <el-collapse class="left-text-content" v-model="activeTipAnswers">
        <el-collapse-item v-for="(item, index) in tipTexts" :key="index" :name="index">
          <span slot="title">{{item.question}}</span>
          <div v-html="item.answer"></div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-else-if="activeName == 'case'">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-select v-model="caseCategory" placeholder="请选择" @change="onCaseCategoryChange">
            <el-option v-for="item in caseCategoryOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <el-select v-model="caseCategorySecord" placeholder="请选择" @change="onCaseCategorySecordChange">
            <el-option v-for="item in caseCategorySecordOptions" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div class="left-text-content" v-html="caseText"></div>
    </div>
    <div v-else-if="activeName == 'verb'">
      <el-select v-model="verbCategory" placeholder="请选择" @change="onVerbCategoryChange" style="width:100%">
        <el-option v-for="(item, index) in verbCategoryOptions" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <div class="left-text-content">
        <el-row>
          <el-col :span="12" v-for="(verb, index) in verbTexts" :key="index">{{verb}}</el-col>
        </el-row>
      </div>
    </div>
  </el-card>
</template>

<script>
  import {
    tipCategoryList,
    tipTextList
  } from '~/static/resumeTipText.js';
  import {
    caseCategoryList,
    caseTextList
  } from '~/static/resumeCaseText.js';
  import {
    verbCategoryList,
    verbTextList
  } from '~/static/commonVerbText.js';
  export default {
    components: {
    },
    data() {
      return {
        activeName: 'tip',
        tipCategory: 1,
        tipCategoryOptions: tipCategoryList,
        tipTexts: [],
        activeTipAnswers: [],
        caseCategoryOptions: caseCategoryList,
        caseCategorySecordOptions: [],
        caseText: '',
        caseCategory: 1,
        caseCategorySecord: '',
        verbCategory: 1,
        verbCategoryOptions: verbCategoryList,
        verbTexts: []
      };
    },
    created() {
      if (this.tipCategory) {
        this.onTipCategoryChange(this.tipCategory);
      }
      if (this.caseCategory) {
        this.onCaseCategoryChange(this.caseCategory);
      }
      if (this.verbCategory) {
        this.onVerbCategoryChange(this.verbCategory);
      }
    },
    methods: {
      onTipCategoryChange(val) {
        this.tipTexts = tipTextList.find(t => t.categoryId === val).children;
        this.activeTipAnswers = [];
      },
      onCaseCategoryChange(val) {
        var caseTexts = caseTextList.find(c => c.categoryId === val).children;
        if (caseTexts) {
          this.caseCategorySecordOptions = caseTexts;
          this.caseCategorySecord = caseTexts[0].value;
          this.onCaseCategorySecordChange(this.caseCategorySecord);
        }
      },
      onCaseCategorySecordChange(val) {
        var caseItem = this.caseCategorySecordOptions.find(c => c.value === val);
        if (caseItem) {
          this.caseText = caseItem.text;
        }
      },
      onVerbCategoryChange(val) {
        this.verbTexts = verbTextList.find(v => v.categoryId === val).children;
      }
    }
  };
</script>

<style>

</style>